import { Box } from "@mantine/core";
import { MdOpenInNew } from "react-icons/md";
import { V2Source } from "../../api";

export interface PlaybookViewerProps {
    source: V2Source | undefined;
}

export const PlaybookViewer = ({ source }: PlaybookViewerProps) => {
    if (!source) {
        return <h1>No Playbook Selected</h1>;
    }

    return (
        <Box>
            <h2>{source?.title}</h2>

            <a href={source.url} target="_blank" rel="noopener noreferrer">
                <MdOpenInNew size={14} />
                View playbook
            </a>
        </Box>
    );
};
